<template>
  <div class="result">
    <div class="result-scroll">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text=""
        @load="onLoad"
      >
        <div class="bj-list">
          <SelectBujiItem
            class="bj-item"
            v-for="(item, index) in resultList"
            :key="index"
            :data="item"
            @add="bindAddBuji"
            @del="bindDeleteBuji"
            @detail="bindClickTonicItem"
          >
          </SelectBujiItem>
        </div>
        <SearchEmpty
          v-show="loaded && !resultList.length"
          @search="bindSearch"
        />
      </van-list>
    </div>
    <ShopCard
      @submit="bindSubmitPlan"
      :create="!planId"
      :data="curSelectList"
      @delete="bindDeleteBuji"
    />
    <van-overlay
      :show="showSelectMethods"
      @click="showSelectMethods = false"
      z-index="5006"
    >
      <SelectMethodsPopup
        :data="selectMethodsData"
        @add="bindAddBujiConfirm"
        @close="bindCloseSelectToast"
      />
    </van-overlay>
  </div>
</template>

<script>
import SelectBujiItem from './select-buji-item.vue'
import ShopCard from './shop-card.vue'
import SelectMethodsPopup from './select-methods-popup.vue'
import SearchEmpty from './search-empty.vue'
import { addCartAnimate } from '@/components/add-cart-animate/index'
export default {
  components: { SelectBujiItem, ShopCard, SelectMethodsPopup, SearchEmpty },
  props: {
    keyword: {
      type: String,
      default: ''
    }
  },
  inject: ['deleteBuji', 'addBuji', 'clickTonicItem', 'submitPlan'],
  data() {
    return {
      planId: 0,
      loaded: false,
      loading: false,
      finished: false,
      resultList: [],
      page: 1,
      selectMethodsData: null,
      showSelectMethods: false
    }
  },
  computed: {
    curSelectList() {
      return this.$store.state.nutritionClock.selectList
    }
  },
  created() {
    this.planId = this.$route.query.planId
  },
  methods: {
    init() {
      this.loaded = false
      this.loading = false
      this.finished = false
      this.page = 1
      this.resultList = []
    },
    bindSearch(item) {
      this.$emit('search', item)
    },
    bindSubmitPlan() {
      this.submitPlan()
    },
    bindCloseSelectToast() {
      this.showSelectMethods = false
    },
    bindDeleteBuji(item) {
      this.deleteBuji(item)
      this.updateResultList(item)
    },
    bindAddBuji(item, event) {
      if (event) {
        const cartEl = document.getElementById('shop-card-icon')
        const addEl = event?.target
        addCartAnimate(addEl, cartEl)
      }
      if (item.usage.length > 1) {
        this.selectMethodsData = item
        this.showSelectMethods = true
      } else {
        this.addBuji(item, 0)
      }
    },
    bindAddBujiConfirm(item, index, event) {
      if (event) {
        const cartEl = document.getElementById('shop-card-icon')
        const addEl = event?.target
        addCartAnimate(addEl, cartEl)
      }
      this.showSelectMethods = false
      this.addBuji(item, index)
    },
    bindClickTonicItem(item) {
      this.clickTonicItem(item)
    },
    //更新删除搜索结果中的选中状态
    updateResultList(obj) {
      this.resultList.map((item) => {
        if (obj.product_id == item.product_id) {
          item.select = false
        }
      })
    },
    async onLoad() {
      let params = {
        keywords: this.keyword,
        plan_id: this.planId,
        page: this.page
      }
      let res = await this.$http
        .postBaseApp('api/v2/search/searchTonicProduct', params)
        .catch(() => {
          this.finished = true
        })
      this.loading = false
      this.loaded = true
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.page++
          if (!res.data || !res.data.data || !res.data.data.length) {
            this.finished = true
          }
          this.resultList = this.resultList.concat(
            this.dealData(res.data.data || [])
          )
        }
      }
    },
    //处理数据
    dealData(data) {
      let selectIds = this.curSelectList.map((item) => {
        return item.product_id
      })
      let reg = RegExp(this.keyword, 'g')
      data.map((item) => {
        item.product_id = item.id
        item.p_title = item.title
        item.keywordTitle = item.title.replace(
          reg,
          '<span style="color:rgba(0, 205, 223, 1);">' +
            this.keyword +
            '</span>'
        )
        // item.p_title = item.title.replace(reg, '<span style="color:rgba(0, 205, 223, 1);">' + this.keyword + '</span>');
        item.select = selectIds.includes(item.product_id)
        item.curSelect = undefined
        if (item.usage) {
          item.usage.map((item1) => {
            item1.time_details = JSON.parse(item1.time_details)
          })
        }
      })
      return data
    }
  }
}
</script>
<style lang="scss" scoped>
.result {
  height: 100%;
  display: flex;
  flex-direction: column;

  .result-scroll {
    flex: 1;
    flex-shrink: 0;
    overflow-y: scroll;
  }
}

.bj-list {
  padding: 0px 4px 0px 10px;

  .bj-item {
    margin-bottom: 20px;
  }
}
</style>
